module.exports = __webpack_public_path__ + "img/muffin-3.224bbd2e.svg";